(function() {
	'use strict';

	var $infoBox = $('.js-question'),
		$tabs = $('.tabs .link'),
		$tabContents = $('.js-tab');

	$infoBox.on('click', function() {
		var $self = $(this),
			$target = $self,
			targetOpened = !!$target.hasClass('expand');

		// Close all boxes
		$infoBox.removeClass('expand');

		// Check current box for toggle
		if (targetOpened) {
			$target.removeClass('expand');
		} else {
			$target.addClass('expand');
		}
	});

	$tabs.on('click', function() {
		var $tabControl = $(this).attr('aria-controls');

		$tabs.removeClass('expand');
		$(this).addClass('expand');

		for(var i = 0; i < $tabContents.length; i++) {
			// hide all sectionTABs on click by default
			$($tabContents[i]).addClass('js-ds-none-tab-content').removeClass('active');

			// if clicked TAB[aria-control] === sectionTAB[id]
			if($tabControl === $($tabContents[i]).attr('id')) {
				$($tabContents[i]).removeClass('js-ds-none-tab-content').addClass('active')
			}
		}


	});

	// GLOWEB-6722
	var tooltipTimeout;

	if ($('[data-toggle="tooltip"]').length) {
		$('[data-toggle="tooltip"]').tooltip();

		$('[data-toggle="tooltip"]').on('shown.bs.tooltip', function () {
			tooltipTimeout = setTimeout(function () {
				dataLayer.push({
					'event': 'av.genericEvent',
					'eventCategory': "adHoc",
					'eventAction': "GLOWEB-6722",
					'eventLabel': "toolTip"
				})
			}, 1000)
		});
	}

	$('[data-toggle="tooltip"]').on('hidden.bs.tooltip', function () {
		clearTimeout(tooltipTimeout)
	})

	if ($('#deal-info').length) {
		$('#deal-info').on('shown.bs.modal', function () {
			dataLayer.push({
				'event': 'av.genericEvent',
				'eventCategory': "adHoc",
				'eventAction': "GLOWEB-6722",
				'eventLabel': "popUp"
			})
		})
	}
	// /GLOWEB-6722


})();

if ($('.slider-sliderSliNotiSecSm').length > 0) {
	var sliderInfNotiSecMed = tns({
		"container": ".slider-sliderSliNotiSecSm",
		"controlsContainer": ".slider-sliderSliNotiSecSm-controls",
		"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"controls": false,
		"navPosition": "bottom",
		"mouseDrag": true,
		"speed": 400,
		"center": false,
		"slideBy": 1,
		"fixedWidth": 250,
		"gutter": 16,
		"loop": false,
		"responsive": {
			"768": {
				"slideBy": 1,
				"controls": false,
				"fixedWidth": 316,
				"gutter": 32
			},
			"1280": {
				"slideBy": 1,
				"controls": true,
				"fixedWidth": 316,
				"gutter": 64
			},
			"1600": {
				"slideBy": 1,
				"controls": true,
				"fixedWidth": 316,
				"gutter": 64
			}
		}
	});
}

if ($('.slider-sliderSliNotiSecSmFeatures').length > 0) {
	var sliderInfNotiSecMed = tns({
		"container": ".slider-sliderSliNotiSecSmFeatures",
		"controlsContainer": ".slider-sliderSliNotiSecSmFeatures-controls",
		"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"controls": false,
		"navPosition": "bottom",
		"mouseDrag": true,
		"speed": 400,
		"center": false,
		"slideBy": 1,
		"fixedWidth": 250,
		"gutter": 16,
		"loop": false,
		"responsive": {
			"768": {
				"slideBy": 1,
				"controls": false,
				"fixedWidth": 316,
				"gutter": 32
			},
			"1280": {
				"slideBy": 1,
				"controls": true,
				"fixedWidth": 316,
				"gutter": 64
			},
			"1600": {
				"slideBy": 1,
				"controls": true,
				"fixedWidth": 290,
				"gutter": 64
			}
		}
	});
}


